/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var CSSCore = require('react/lib/CSSCore');
var Router = require('react-router');
var $__0=    require('../../../../'),Seq=$__0.Seq;
var TypeKind = require('../../../lib/TypeKind');
var defs = require('../../../lib/getTypeDefs');

var InterfaceDef = React.createClass({displayName: "InterfaceDef",
  render:function() {
    var name = this.props.name;
    var def = this.props.def;
    return (
      React.createElement("span", {className: "t interfaceDef"}, 
        React.createElement("span", {className: "t keyword"}, "type "), 
        React.createElement("span", {className: "t typeName"}, name), 
        def.typeParams && [
          '<',
          Seq(def.typeParams)
            .map(function(t, k)  
              {return React.createElement("span", {className: "t typeParam", key: k}, 
                t
              );}
            )
            .interpose(', ')
            .toArray(),
          '>',
        ], 
        def.extends && [
          React.createElement("span", {className: "t keyword"}, " extends "),
          Seq(def.extends)
            .map(function(e, i)  {return React.createElement(TypeDef, {key: i, type: e});})
            .interpose(', ')
            .toArray(),
        ], 
        def.implements && [
          React.createElement("span", {className: "t keyword"}, " implements "),
          Seq(def.implements)
            .map(function(e, i)  {return React.createElement(TypeDef, {key: i, type: e});})
            .interpose(', ')
            .toArray(),
        ]
      )
    );
  },
});

exports.InterfaceDef = InterfaceDef;

var CallSigDef = React.createClass({displayName: "CallSigDef",
  render:function() {
    var info = this.props.info;
    var module = this.props.module;
    var name = this.props.name;
    var callSig = this.props.callSig || {};

    var shouldWrap = callSigLength(info, module, name, callSig) > 80;

    return (
      React.createElement("span", {className: "t callSig"}, 
        module && [React.createElement("span", {className: "t fnQualifier"}, module), '.'], 
        React.createElement("span", {className: "t fnName"}, name), 
        callSig.typeParams && [
          '<',
          Seq(callSig.typeParams)
            .map(function(t)  {return React.createElement("span", {className: "t typeParam"}, t);})
            .interpose(', ')
            .toArray(),
          '>',
        ], 
        '(', 
        callSig && functionParams(info, callSig.params, shouldWrap), 
        ')', 
        callSig.type && [': ', React.createElement(TypeDef, {info: info, type: callSig.type})]
      )
    );
  },
});

exports.CallSigDef = CallSigDef;

var TypeDef = React.createClass({displayName: "TypeDef",
  render:function() {
    var info = this.props.info;
    var type = this.props.type;
    var prefix = this.props.prefix;
    switch (type.k) {
      case TypeKind.Never:
        return this.wrap('primitive', 'never');
      case TypeKind.Any:
        return this.wrap('primitive', 'any');
      case TypeKind.This:
        return this.wrap('primitive', 'this');
      case TypeKind.Undefined:
        return this.wrap('primitive', 'undefined');
      case TypeKind.Boolean:
        return this.wrap('primitive', 'boolean');
      case TypeKind.Number:
        return this.wrap('primitive', 'number');
      case TypeKind.String:
        return this.wrap('primitive', 'string');
      case TypeKind.Union:
        return this.wrap('union', [
          Seq(type.types)
            .map(function(t)  {return React.createElement(TypeDef, {info: info, type: t});})
            .interpose(' | ')
            .toArray(),
        ]);
      case TypeKind.Intersection:
        return this.wrap('intersection', [
          Seq(type.types)
            .map(function(t)  {return React.createElement(TypeDef, {info: info, type: t});})
            .interpose(' & ')
            .toArray(),
        ]);
      case TypeKind.Tuple:
        return this.wrap('tuple', [
          '[',
          Seq(type.types)
            .map(function(t)  {return React.createElement(TypeDef, {info: info, type: t});})
            .interpose(', ')
            .toArray(),
          ']',
        ]);
      case TypeKind.Object:
        return this.wrap('object', [
          '{',
          Seq(type.members)
            .map(function(t)  {return React.createElement(MemberDef, {member: t});})
            .interpose(', ')
            .toArray(),
          '}',
        ]);
      case TypeKind.Indexed:
        return this.wrap('indexed', [
          React.createElement(TypeDef, {info: info, type: type.type}),
          '[',
          React.createElement(TypeDef, {info: info, type: type.index}),
          ']',
        ]);
      case TypeKind.Operator:
        return this.wrap('operator', [
          this.wrap('primitive', type.operator),
          ' ',
          React.createElement(TypeDef, {info: info, type: type.type}),
        ]);
      case TypeKind.Array:
        return this.wrap('array', [
          React.createElement(TypeDef, {info: info, type: type.type}),
          '[]',
        ]);
      case TypeKind.Function:
        var shouldWrap = (prefix || 0) + funcLength(info, type) > 78;
        return this.wrap('function', [
          type.typeParams && [
            '<',
            Seq(type.typeParams)
              .map(function(t, k)  
                {return React.createElement("span", {className: "t typeParam", key: k}, 
                  t
                );}
              )
              .interpose(', ')
              .toArray(),
            '>',
          ],
          '(',
          functionParams(info, type.params, shouldWrap),
          ') => ',
          React.createElement(TypeDef, {info: info, type: type.type}),
        ]);
      case TypeKind.Param:
        return info && info.propMap[info.defining + '<' + type.param] ? (
          React.createElement(TypeDef, {type: info.propMap[info.defining + '<' + type.param]})
        ) : (
          this.wrap('typeParam', type.param)
        );
      case TypeKind.Type:
        var qualifiedType = (type.qualifier || []).concat([type.name]);
        var qualifiedTypeName = qualifiedType.join('.');
        var def = qualifiedTypeName
          .split('.')
          .reduce(
            function(def, name)  {return def && def.module && def.module[name];},
            defs.Immutable
          );
        var typeNameElement = [
          type.qualifier && [
            Seq(type.qualifier)
              .map(function(q)  {return React.createElement("span", {className: "t typeQualifier"}, q);})
              .interpose('.')
              .toArray(),
            '.',
          ],
          React.createElement("span", {className: "t typeName"}, type.name),
        ];
        if (def) {
          typeNameElement = (
            React.createElement(Router.Link, {to: '/' + qualifiedTypeName}, 
              typeNameElement
            )
          );
        }
        return this.wrap('type', [
          typeNameElement,
          type.args && [
            '<',
            Seq(type.args)
              .map(function(a)  {return React.createElement(TypeDef, {info: info, type: a});})
              .interpose(', ')
              .toArray(),
            '>',
          ],
        ]);
    }
    throw new Error('Unknown kind ' + type.k);
  },

  mouseOver:function(event) {
    CSSCore.addClass(this.getDOMNode(), 'over');
    event.stopPropagation();
  },

  mouseOut:function() {
    CSSCore.removeClass(this.getDOMNode(), 'over');
  },

  wrap:function(className, child) {
    return (
      React.createElement("span", {
        className: 't ' + className, 
        onMouseOver: this.mouseOver, 
        onFocus: this.mouseOver, 
        onMouseOut: this.mouseOut, 
        onBlur: this.mouseOut
      }, 
        child
      )
    );
  },
});

exports.TypeDef = TypeDef;

var MemberDef = React.createClass({displayName: "MemberDef",
  render:function() {
    var module = this.props.module;
    var member = this.props.member;
    return (
      React.createElement("span", {className: "t member"}, 
        module && [React.createElement("span", {className: "t fnQualifier"}, module), '.'], 
        member.index ? (
          ['[', functionParams(null, member.params), ']']
        ) : (
          React.createElement("span", {className: "t memberName"}, member.name)
        ), 
        member.type && [': ', React.createElement(TypeDef, {type: member.type})]
      )
    );
  },
});

exports.MemberDef = MemberDef;

function functionParams(info, params, shouldWrap) {
  var elements = Seq(params)
    .map(function(t)  {return [
      t.varArgs ? '...' : null,
      React.createElement("span", {className: "t param"}, t.name),
      t.optional ? '?: ' : ': ',
      React.createElement(TypeDef, {
        prefix: t.name.length + (t.varArgs ? 3 : 0) + (t.optional ? 3 : 2), 
        info: info, 
        type: t.type}
      ),
    ];})
    .interpose(shouldWrap ? [',', React.createElement("br", null)] : ', ')
    .toArray();
  return shouldWrap ? (
    React.createElement("div", {className: "t blockParams"}, elements)
  ) : (
    elements
  );
}

function callSigLength(info, module, name, sig) {
  return (module ? module.length + 1 : 0) + name.length + funcLength(info, sig);
}

function funcLength(info, sig) {
  return (
    (sig.typeParams ? 2 + sig.typeParams.join(', ').length : 0) +
    2 +
    (sig.params ? paramLength(info, sig.params) : 0) +
    (sig.type ? 2 + typeLength(info, sig.type) : 0)
  );
}

function paramLength(info, params) {
  return params.reduce(
    function(s, p) 
      {return s +
      (p.varArgs ? 3 : 0) +
      p.name.length +
      (p.optional ? 3 : 2) +
      typeLength(info, p.type);},
    (params.length - 1) * 2
  );
}

function memberLength(info, members) {
  return members.reduce(
    function(s, m) 
      {return s +
      (m.index ? paramLength(info, m.params) + 4 : m.name + 2) +
      typeLength(info, m.type);},
    (members.length - 1) * 2
  );
}

function typeLength(info, type) {
  if (!type) {
    throw new Error('Expected type');
  }
  switch (type.k) {
    case TypeKind.Never:
      return 5;
    case TypeKind.Any:
      return 3;
    case TypeKind.This:
      return 4;
    case TypeKind.Undefined:
      return 9;
    case TypeKind.Boolean:
      return 7;
    case TypeKind.Number:
      return 6;
    case TypeKind.String:
      return 6;
    case TypeKind.Union:
    case TypeKind.Intersection:
      return (
        type.types.reduce(function(s, t)  {return s + typeLength(info, t);}, 0) +
        (type.types.length - 1) * 3
      );
    case TypeKind.Tuple:
      return (
        2 +
        type.types.reduce(function(s, t)  {return s + typeLength(info, t);}, 0) +
        (type.types.length - 1) * 2
      );
    case TypeKind.Object:
      return 2 + memberLength(info, type.members);
    case TypeKind.Indexed:
      return 2 + typeLength(info, type.type) + typeLength(info, type.index);
    case TypeKind.Operator:
      return 1 + type.operator.length + typeLength(info, type.type);
    case TypeKind.Array:
      return typeLength(info, type.type) + 2;
    case TypeKind.Function:
      return 2 + funcLength(info, type);
    case TypeKind.Param:
      return info && info.propMap[info.defining + '<' + type.param]
        ? typeLength(null, info.propMap[info.defining + '<' + type.param])
        : type.param.length;
    case TypeKind.Type:
      return (
        (type.qualifier ? 1 + type.qualifier.join('.').length : 0) +
        type.name.length +
        (!type.args
          ? 0
          : type.args.reduce(
              function(s, a)  {return s + typeLength(info, a);},
              type.args.length * 2
            ))
      );
  }
  throw new Error('Type with unknown kind ' + JSON.stringify(type));
}
